/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line no-shadow
export enum IntakeFlowStep {
  WELCOME = 'WELCOME',
  WHAT_YOU_DO = 'WHAT_YOU_DO',
  NEED_PROFILER_INFO = 'NEED_PROFILE_INFO',
  ORG_SUMMARY = 'ORG_SUMMARY',
  IMPACT_AREAS = 'IMPACT_AREAS',
  TOP_PRIORITIES = 'TOP_PRIORITIES',
  CONFIDENCE_RATING = 'CONFIDENCE_RATING',
  OTHER_FOCUS_AREAS = 'OTHER_FOCUS_AREAS',
  LOADING_IMPACT_PLAN = 'LOADING_IMPACT_PLAN',
  IMPACT_PLAN = 'IMPACT_PLAN',
}

export const STEPPER_GROUPS = [
  {
    title: 'Getting To Know You',
    steps: [IntakeFlowStep.WELCOME, IntakeFlowStep.WHAT_YOU_DO],
  },
  {
    title: 'Customizing Your Experience',
    steps: [
      IntakeFlowStep.NEED_PROFILER_INFO,
      IntakeFlowStep.ORG_SUMMARY,
      IntakeFlowStep.IMPACT_AREAS,
      IntakeFlowStep.TOP_PRIORITIES,
      IntakeFlowStep.CONFIDENCE_RATING,
      IntakeFlowStep.OTHER_FOCUS_AREAS,
    ],
  },
  {
    title: 'Your Impact Plan',
    steps: [IntakeFlowStep.LOADING_IMPACT_PLAN, IntakeFlowStep.IMPACT_PLAN],
  },
]

/*
  TODO: the priority to params mapping logic is a little duplicative of nonprofitAcademyTopics in 
  web/src/Components/Pages/Academy/Resources/SearchPage/nonprofitAcademyTopics.ts.
  We should refactor and consolidate these together.
*/

// /* eslint-disable @typescript-eslint/naming-convention */
export type Priority =
  | 'Board Management'
  | 'Compliance'
  | 'Data & Impact'
  | 'Diversity, Equity, & Inclusion'
  | 'Accessibility'
  | 'Event Management'
  | 'Finance'
  | 'Formation'
  | 'Fundraising'
  | 'Grants'
  | 'Marketing & Communications'
  | 'People Operations'
  | 'Program Management'
  | 'Storytelling'
  | 'Strategic Planning'
  | 'Technology Solutions'
  | 'Volunteer Management'

export const priorityToParam: Record<Priority, string> = {
  'Board Management': 'Board+Management',
  Compliance: 'Compliance',
  'Data & Impact': 'Data+%26+Impact',
  'Diversity, Equity, & Inclusion': 'DEI+%26+Accessibility',
  Accessibility: 'DEI+%26+Accessibility',
  'Event Management': 'Event+Management',
  Finance: 'Finance',
  Formation: 'Formation',
  Fundraising: 'Fundraising',
  Grants: 'Grants',
  'Marketing & Communications': 'Marketing+Communications',
  'People Operations': 'People+Operations',
  'Program Management': 'Program+Management',
  Storytelling: 'Storytelling',
  'Strategic Planning': 'Strategic+Planning',
  'Technology Solutions': 'Technology+Solutions',
  'Volunteer Management': 'Volunteer+Management',
}
